/* eslint-disable */
import React from "react";
import EndpointHitter from "../../../ui-components/endpoint-hitter/endpoint-hitter";
import { useState } from "react";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";

const NimbusDeveloperToolsAPIHitters = () => {
  const [response, setResponse] = useState(null);

  return (
    <div className="flex flex-row gap-4 justify-around w-full h-full overflow-scroll items-center p-6">
      <div className="flex flex-col max-w-lg w-full h-full">
        <RaindropScrollContainer>
          <EndpointHitter
            title={"Demo Heartbeat"}
            endpoint={"cronjob/v1/heartbeat-demo-site"}
            method={"GET"}
            setResponse={setResponse}
          />
          <EndpointHitter
            title={"Execute AccountPlan objects"}
            endpoint={"cronjob/v1/account-plans-execute"}
            description="Create the associated AccountPlanExecution objects for all active AccountPlan objects."
            method={"GET"}
            setResponse={setResponse}
          />

          <EndpointHitter
            title={"Create OrganisationTransfers"}
            endpoint={"cronjob/v1/organisation-transfers-execute"}
            description="Create the organisation transfer objects."
            method={"GET"}
            setResponse={setResponse}
          />
          <EndpointHitter
            title={"Populate Database"}
            endpoint={"api/v1/developer-tools/populate-database"}
            method={"POST"}
            setResponse={setResponse}
          />

          <EndpointHitter
            title={"Get one-off scripts"}
            endpoint={"api/v1/developer-tools/scripts"}
            method={"GET"}
            setResponse={setResponse}
          />

          <EndpointHitter
            title={"Playground"}
            description={
              "This is an endpoint mostly helpful for development.  Don't worry about setting up a specific endpoint if you just want to play around.  Just use this one and delete your code once everything is working and in the right place."
            }
            endpoint={"api/v1/developer-tools/playground"}
            method={"GET"}
            setResponse={setResponse}
          />
        </RaindropScrollContainer>
      </div>

      <div className="flex flex-col w-full max-w-lg h-96 overflow-scroll items-center justify-center">
        <pre
          className="h-full  rounded-lg flex flex-col items-start p-4 w-full overflow-scroll text-xs
        bg-color-raindrop-disabled dark:bg-color-raindrop-disabled
        text-color-dark-text-primary
        "
        >
          {response}
        </pre>
      </div>
    </div>
  );
};

export default NimbusDeveloperToolsAPIHitters;
